import {useNavigate} from "react-router-dom";
import { useState, FormEvent } from "react";
import { UseAPICaller } from "../apiCaller.tsx";
import { UseAuth } from "../AuthContext.tsx";

import "../css/SignIn.css";


function SignIn()
{
    document.body.classList.add("SignIn-page");

    const [isLogin, setIsLogIn] = useState(true);
    const [errorMsg, setErrorMsg] = useState("");
    const [password, setPassword] = useState("");
    const [confPassword, setConfPassword] = useState("");
    const [company, setCompany] = useState("");

    const {Login} = UseAuth();
    const {CheckLogin, AddNewCompany} =UseAPICaller();

    let navigate = useNavigate();


    function SwitchState()
    {
        setIsLogIn(!isLogin);
        setErrorMsg("");
    }

    async function HandleSubmit(e: FormEvent)
    {
        e.preventDefault();
        setErrorMsg("");
        if(isLogin)
        {
            const response = await CheckLogin(company, password);
            if (response) 
            {
                Login(response)
                document.body.classList.remove("SignIn-page");
                navigate("/dashboard");
            }
            else
            {
                setErrorMsg("Invalid username or password.")
            }
        }
        else
        {
            if (password !== confPassword)
            {
                setErrorMsg("The passwords doesn't match.")
                return;
            }
            
            const response = await AddNewCompany(company, password);
            
            if (response && response.companyId) 
            {
                alert(`Company: ${company} created`);
                setIsLogIn(true);
                setCompany("");
                setPassword("");
                setConfPassword("");    
            }
            else
            {
                console.error("Error:", response.status);
            }
        }
    }

    return (
        <div className="background-container">
            <h1 className="background-title">SOCIAL VALUE MEASUREMENT AND COMMUNICATION TOOL</h1>
            <div className="image-wrapper">
                <div className="image-container">
                    <img src="/images/SignInBackground.png" className="background-image"></img>
                    <img className="logo-bird" src="/images/NPABirdV2BlueGradientRGB.png" alt="bird"></img>
                </div>
            </div>
            <div className="footer-wrapper">
                <img className="logo-bottom" src="/images/MERSE_logo.webp" alt="npa"></img>
            </div>
            <div className="login-overlay">
                <div className="window-container">
                    <div className="header">
                        <h1>{isLogin ? "Sign In" : "Sign Up"}</h1>
                    </div>
                    <div>
                        {errorMsg === "" ? <></> : <span className="error-text">{errorMsg}</span>}
                    </div>
                    <form className="signin-form" onSubmit={HandleSubmit}>
                        <div>
                            <div className="input">
                                <label className="input-label">Company Name</label>
                                <input type="text" value={company} onChange={e => setCompany(e.target.value)}></input>
                            </div>
                            <div className="input">
                                <label className="input-label">Password</label>
                                <input type="password" value={password} onChange={e => setPassword(e.target.value)}></input>
                            </div>
                            {!isLogin && (
                                <div className="input">
                                <label className="input-label">Confirm Password</label>
                                <input type="password" value={confPassword} onChange={e => setConfPassword(e.target.value)}></input>
                            </div>
                            )}
                        </div>
                        <div>
                            <button className="submit-button" >{isLogin ? "Sign In" : "Sign up"}</button>
                        </div>
                        <div className="state-switch-text">
                            <div>{isLogin ? "Not a member?" : "Already a member? "}<span onClick={() => SwitchState()}>{isLogin ? "Sign up now" : "Log in"}</span></div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default SignIn;